import { useState } from 'react';
import { Link } from 'react-router-dom';

const modules = [
  {
    number: '01',
    icon: 'ri-book-open-line',
    title: 'مقدمة في ATS',
    description: 'التعرف على نظام التحويل التلقائي، أنواعه، مبدأ عمله، وأهميته في المنظومات الكهربائية الصناعية.',
  },
  {
    number: '02',
    icon: 'ri-cpu-line',
    title: 'مكونات دائرة ATS',
    description: 'دراسة تفصيلية لجميع مكونات الدائرة: الكونتاكتورات، الريليات، المفاتيح، والمصادر الاحتياطية.',
  },
  {
    number: '03',
    icon: 'ri-settings-3-line',
    title: 'التوصيل والتركيب',
    description: 'خطوات التوصيل العملي للوحة ATS من الصفر، مع شرح مفصل للرسومات الكهربائية والمخططات.',
  },
  {
    number: '04',
    icon: 'ri-shield-check-line',
    title: 'الحماية والأمان',
    description: 'أنظمة الحماية الكهربائية، الفيوزات، القواطع، وكيفية ضبط إعدادات الحماية بشكل صحيح.',
  },
  {
    number: '05',
    icon: 'ri-file-chart-line',
    title: 'الرسومات الكهربائية',
    description: 'قراءة وتفسير مخططات ATS الكهربائية، Single Line Diagram، وكيفية رسم المخططات باحتراف.',
  },
  {
    number: '06',
    icon: 'ri-tools-line',
    title: 'الصيانة وحل الأعطال',
    description: 'أساليب الصيانة الدورية، تشخيص الأعطال الشائعة، وكيفية إصلاحها بسرعة وكفاءة عالية.',
  },
];

const faqs = [
  {
    q: 'من هو الجمهور المستهدف لهذا الكورس؟',
    a: 'الكورس مناسب للمهندسين الكهربائيين، الفنيين، وطلاب الهندسة الراغبين في التخصص في أنظمة التحويل التلقائي.',
  },
  {
    q: 'هل يحتاج الكورس لخبرة مسبقة؟',
    a: 'يكفي أن يكون لديك معرفة أساسية بالكهرباء. الكورس يبدأ من المستوى المبتدئ ويصل للمتقدم.',
  },
  {
    q: 'كيف أتواصل للتسجيل؟',
    a: 'يمكنك التسجيل مباشرة عبر واتساب بالضغط على زر التسجيل أدناه وسيتم التواصل معك فوراً.',
  },
];

export default function ATSCoursePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div
      className="min-h-screen flex flex-col relative overflow-hidden"
      style={{ background: 'linear-gradient(160deg, #1a1a1a 0%, #2a2a2a 50%, #1a1a1a 100%)' }}
      dir="rtl"
    >
      {/* Background decorative */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute top-[-120px] left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full opacity-10"
          style={{ background: 'radial-gradient(circle, #F5A623 0%, transparent 70%)' }}
        />
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              'linear-gradient(#F5A623 1px, transparent 1px), linear-gradient(90deg, #F5A623 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
      </div>

      {/* Header */}
      <header
        className="sticky top-0 z-50"
        style={{
          background: 'rgba(26,26,26,0.95)',
          borderBottom: '1px solid rgba(245,166,35,0.2)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/645339dfad8e1015d6f60a0aacde7112/7ac018fe95b5893e2914eabc8075ecee.png"
              alt="Logo"
              className="h-12 w-12 object-contain"
            />
            <span className="font-bold text-white text-sm hidden sm:block">للتأسيسات والسيطرة الكهربائية QC</span>
          </Link>
          <nav className="flex items-center gap-2">
            <Link to="/" className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium text-gray-300 hover:text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-home-line"></i>
              <span>الرئيسية</span>
            </Link>
            <Link to="/products" className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium text-gray-300 hover:text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-tools-line"></i>
              <span>خدماتنا</span>
            </Link>
            <Link to="/calculations" className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium text-gray-300 hover:text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-calculator-line"></i>
              <span>الحسابات</span>
            </Link>
            <span
              className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium text-white whitespace-nowrap"
              style={{ background: '#F5A623', boxShadow: '0 2px 12px rgba(245,166,35,0.4)' }}
            >
              <i className="ri-graduation-cap-line"></i>
              <span>كورس ATS</span>
            </span>
            <Link to="/contact" className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium text-gray-300 hover:text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-customer-service-2-line"></i>
              <span>تواصل معنا</span>
            </Link>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=automatic%20transfer%20switch%20ATS%20electrical%20panel%20industrial%20training%20course%2C%20professional%20electrical%20engineer%20teaching%20in%20front%20of%20control%20panel%20with%20circuit%20breakers%20and%20wiring%2C%20warm%20orange%20lighting%2C%20modern%20industrial%20facility%2C%20high%20quality%20photography&width=1400&height=420&seq=ats-hero-001&orientation=landscape"
            alt="كورس ATS"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
        </div>
        <div className="relative z-10 w-full px-4 py-24 text-center text-white">
          <span
            className="inline-block text-white text-xs font-bold px-4 py-1.5 rounded-full mb-5 tracking-wide"
            style={{ background: '#F5A623' }}
          >
              كورس متخصص للمهندسين والفنيين
          </span>
          <h1 className="text-4xl sm:text-5xl font-extrabold mb-4 drop-shadow-lg">
            كورس <span className="text-[#F5A623]">ATS</span> الاحترافي
          </h1>
          <p className="text-base sm:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-7">
            تعلّم تصميم وتركيب وصيانة لوحات التحويل التلقائي ATS من الصفر حتى الاحتراف 
          </p>
          <a
            href="https://wa.me/9647779577796?text=أريد التسجيل في كورس ATS"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold px-8 py-3.5 rounded-full shadow-lg transition-all cursor-pointer whitespace-nowrap text-sm"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            سجّل الآن عبر واتساب
          </a>
        </div>
      </section>

      {/* What you'll learn */}
      <section
        className="relative z-10 py-14 px-4"
        style={{ background: 'rgba(255,255,255,0.03)', borderTop: '1px solid rgba(255,255,255,0.05)', borderBottom: '1px solid rgba(255,255,255,0.05)' }}
      >
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">ماذا ستتعلم؟</h2>
            <p className="text-gray-400 text-sm">محتوى شامل ومتكامل يغطي جميع جوانب نظام ATS</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              'فهم مبدأ عمل نظام ATS بشكل كامل',
              'قراءة وتفسير المخططات الكهربائية',
              'توصيل وتركيب لوحة ATS من الصفر',
              'تشخيص الأعطال وإصلاحها',
              'رسم Single Line Diagram باحتراف',
            ].map((item, i) => (
              <div
                key={i}
                className="flex items-center gap-3 p-3 rounded-xl"
                style={{ background: 'rgba(245,166,35,0.08)', border: '1px solid rgba(245,166,35,0.2)' }}
              >
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F5A623] flex-shrink-0">
                  <i className="ri-check-line text-white text-xs"></i>
                </div>
                <span className="text-sm text-gray-200 font-medium">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modules */}
      <section className="relative z-10 py-14 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">محتوى الكورس</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {modules.map((mod) => (
              <div
                key={mod.number}
                className="rounded-2xl p-6 hover:-translate-y-1 transition-all duration-300 cursor-default"
                style={{
                  background: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(245,166,35,0.15)',
                  backdropFilter: 'blur(10px)',
                }}
              >
                <div className="flex items-center justify-between mb-4">
                  <span className="text-3xl font-extrabold text-[#F5A623]/30">{mod.number}</span>
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-full"
                    style={{ background: 'rgba(245,166,35,0.15)' }}
                  >
                    <i className={`${mod.icon} text-[#F5A623] text-lg`}></i>
                  </div>
                </div>
                <h3 className="text-base font-bold text-white mb-2">{mod.title}</h3>
                <p className="text-xs text-gray-400 leading-6">{mod.description}</p>
              </div>
            ))}
          </div>

          {/* Course Includes */}
          <div
            className="mt-10 rounded-2xl p-8"
            style={{
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(245,166,35,0.15)',
              backdropFilter: 'blur(10px)',
            }}
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full" style={{ background: 'rgba(245,166,35,0.15)' }}>
                <i className="ri-gift-line text-[#F5A623] text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-white">ماذا يشمل الكورس؟</h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: 'ri-video-line', text: 'فيديوهات مسجلة بدقة عالية ومحمية' },
                { icon: 'ri-plug-line', text: '3 كونتكتورات', image: '/contactor.png' },
                { icon: 'ri-cpu-line', text: '3 ريليات', image: '/relay.png' },
                { 
  icon: 'ri-shield-flash-line', 
  text: 'جوزة حماية ضد ارتفاع وانخفاض الفولتية',
  image: '/protector.png'
},
                { icon: 'ri-usb-flash-drive-line', text: 'فلاش ميموري 8 جيجا', image: 'https://static.readdy.ai/image/645339dfad8e1015d6f60a0aacde7112/8e87973e29f892db9b30f0d8220c30a0.png' },
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 p-3 rounded-xl"
                  style={{ background: 'rgba(245,166,35,0.08)', border: '1px solid rgba(245,166,35,0.2)' }}
                >
                  <div className="w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 overflow-hidden" style={{ background: 'rgba(245,166,35,0.15)' }}>
  {item.image ? (
    <img src={item.image} alt="" className="w-full h-full object-contain p-1" />
  ) : (
    <i className={`${item.icon} text-[#F5A623] text-sm`}></i>
  )}
</div>
                  <span className="text-sm text-gray-200 font-medium flex-1">{item.text}</span>
                  {item.image && (
                    <div className="w-14 h-14 flex-shrink-0">
                      <img src={item.image} alt="فلاش ميموري" className="w-full h-full object-contain" />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="relative z-10 py-14 px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">الأسئلة الشائعة</h2>
          </div>
          <div className="flex flex-col gap-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="rounded-xl overflow-hidden"
                style={{
                  background: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(245,166,35,0.15)',
                }}
              >
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  className="w-full flex items-center justify-between px-5 py-4 text-right cursor-pointer"
                >
                  <span className="text-sm font-semibold text-white">{faq.q}</span>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className={`ri-arrow-down-s-line text-[#F5A623] text-lg transition-transform duration-300 ${openFaq === i ? 'rotate-180' : ''}`}></i>
                  </div>
                </button>
                {openFaq === i && (
                  <div className="px-5 pb-4 text-sm text-gray-400 leading-7" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative overflow-hidden py-16 px-4">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=electrical%20engineering%20training%20workshop%20with%20ATS%20panels%20and%20circuit%20boards%2C%20dark%20industrial%20background%20with%20orange%20glowing%20lights%2C%20professional%20atmosphere%2C%20abstract%20technology%20pattern&width=1400&height=320&seq=ats-cta-002&orientation=landscape"
            alt="سجّل الآن"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/65 to-black/75"></div>
        </div>
        <div className="relative z-10 text-center text-white max-w-2xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold mb-3">جاهز تبدأ رحلتك مع ATS؟</h2>
          <p className="text-white/80 text-sm mb-8">سجّل الآن وانضم لمئات المهندسين الذين احترفوا تصميم لوحات ATS</p>
          <a
            href="https://wa.me/9647779577796?text=أريد التسجيل في كورس ATS"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold px-10 py-4 rounded-full shadow-xl transition-all cursor-pointer whitespace-nowrap text-sm"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            سجّل الآن عبر واتساب
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer
        className="relative z-10 py-5 text-center"
        style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}
      >
        <p className="text-xs text-gray-500">
          تم البرمجة من قبل{' '}
          <span className="font-bold text-[#F5A623]">Murthdha abdulzahra</span>
        </p>
      </footer>
    </div>
  );
}
